jQuery(document).ready(function($) {
    new Swiper('.blog-hero-swiper', {
        loop: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function(index, className) {
                return '<span class=\"' + className + '\"></span>';
            }
        }
    });
});